import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const LCP_IMAGE = 'https://cdn.magicpatterns.com/uploads/mc4uBy6kEVsGDkCRAsGaMz/ChatGPT_Image_15_jun_2026,_13_29_32-Photoroom.png';
function loadMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', '1181648490064668');
  w.fbq('track', 'PageView');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=1181648490064668&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
export function App() {
  useEffect(() => {
    // Preload LCP image for faster discovery
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = LCP_IMAGE;
    document.head.appendChild(preload);
    // Preconnect to external origins
    const origins = ['https://connect.facebook.net', 'https://www.facebook.com'];
    origins.forEach(origin => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      document.head.appendChild(link);
    });
    // Defer Meta Pixel — load when browser is idle to reduce main thread work
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadMetaPixel, {
        timeout: 3500
      });
    } else {
      setTimeout(loadMetaPixel, 2000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}